import { EndpointBuilder } from '@reduxjs/toolkit/query/react';
import { PaymentLinkParams, PaymentLinkResponse, Invoice, GetPaymentServicesResponse } from './types';
import { ApiBaseQuery, ApiTagTypes } from '../types';

/**
 * Endpoints для работы с оплатой
 */
export const paymentEndpoints = (builder: EndpointBuilder<ApiBaseQuery, ApiTagTypes, 'api'>) => ({
    /**
     * Получение ссылки на оплату
     */
    getPaymentLink: builder.query<PaymentLinkResponse, PaymentLinkParams>({
        query: ({ price }) => ({
            url: '/private/payment/link',
            params: {
                price: price,
            },
        }),
    }),
    /**
     * Получение истории фактур
     */
    getInvoices: builder.query<Invoice[], void>({
        query: () => ({
            url: '/private/payment/invoices',
        }),
    }),
    /**
     * Получение списаний за доп. услуги (404 → моковые данные)
     */
    getPaymentServices: builder.query<GetPaymentServicesResponse, void>({
        query: () => ({
            url: '/private/payment/services',
        }),
    }),
});
